module.exports = __webpack_public_path__ + "img/gpic7.png";